
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <v-row class="d-flex justify-center mt-3">
                <sigfoco-date-picker
                    :cols="2"
                    label="Início do período"
                    v-model="form.filters.inicioPeriodo"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
                <sigfoco-date-picker
                    :cols="2"
                    label="Fim do período"
                    v-model="form.filters.fimPeriodo"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
                <v-col cols="3">
                  <v-autocomplete
                    label="Perfil"
                    :items="form.lists.listPerfis"
                    item-text="nome"
                    item-value="id"
                    v-model="form.filters.perfil"
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <sigfoco-select-ativo
                    :cols="2"
                    v-model="form.filters.situacao"
                    labelType="Situação"
                ></sigfoco-select-ativo>
            </v-row>
            <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                    :cols="2"
                    label="Data Início"
                    v-model="form.filters.dataInicio"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
                <sigfoco-date-picker
                    :cols="2"
                    v-model="form.filters.dataFim"
                    label="Data Final"
                    removeIcon
                    outlined
                    dense
                ></sigfoco-date-picker>
            </v-row>
            <div class="text-center">
                <v-col cols="12">
                <sigfoco-tooltip
                    text="Buscar"
                    icon="mdi-magnify"
                    @click="buscarRelatorios"
                ></sigfoco-tooltip>
                <sigfoco-tooltip
                    text="Limpar"
                    icon="mdi-eraser"
                    @click="resetForm"
                ></sigfoco-tooltip>
                </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5 printable"
          :headers="headersAnalitico"
          :items="form.lists.listRelatorios"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
          sort-by="dataHoraDaAcao"
          :sort-desc="true"
          show-expand
          item-key="id"
          :expanded.sync="expanded"
        >
          <template v-slot:[`item.inicioPeriodo`]="{ item }">
            {{ $formatarData(item.inicioPeriodo) }}
          </template>
          <template v-slot:[`item.fimPeriodo`]="{ item }">
            {{ $formatarData(item.fimPeriodo) }}
          </template>
          <template v-slot:[`item.perfil`]="{ item }">
             {{ item.perfil }}
            </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.situacao"></sigfoco-label-ativo-inativo>
          </template>
          <template v-slot:[`item.dataHoraDaAcao`]="{ item }">
            {{ $formatarDataHora(item.dataHoraDaAcao) }}
          </template>
          <template v-slot:[`item.acao`]="{ item }">
            {{ item.acao }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td class="perfis" :colspan="headers.length">
              <v-chip-group active-class="primary--text" column>
                <v-chip
                  class="chip-permissao"
                  v-for="(perfil, i) in item.perfis"
                  :key="i"
                >
                  <v-icon class="perfil" small>mdi-account-multiple</v-icon>
                  {{ perfil.nome }}
                </v-chip>
              </v-chip-group>
            </td>
          </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorios.length"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
    import pageLoadingMixin from "mixins/page-loading.mixin";
    import ManterPerfilService from '~/services/manter-perfil.service';
    import RelatorioDeLog from "services/relatorios-log/manter-periodo-formacao-log.service"
    export default {
        name: "RelatorioLogPeriodoFormacao",
        mixins: [pageLoadingMixin, RelatorioDeLog, ManterPerfilService],
    
        data: () => ({
        onReport: false,
        form: {
            filters: {
                inicioPeriodo: null,
                fimPeriodo: null,
                perfil: null,
                situacao: null,
                dataInicio: null,
                dataFim: null,
            },
            lists: {
                listRelatorios: [],
                tipos: [],
                listPerfis: [],
            },
        },
        headersAnalitico: [
          { text: "Início do Período", align: "center", value: "inicioPeriodo" },
          { text: "Fim do Período", align: "center", value: "fimPeriodo" },
          { text: "Perfil", align: "center", value: "data-table-expand" },
          { text: "Situação", align: "center", value: "situacao" },
          { text: "Data/Hora da ação", align: "center", value: "dataHoraDaAcao" },
          { text: "Ação", align: "center", value: "acao" },
        ],
        }),
        methods: {
        async buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            if (!this.verificarFiltrosPreenchidos()) return;
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogPeriodoFormacao({ params: this.form.filters });
            this.processarRespostaRelatorio(data);
            } finally {
            this.hidePageLoading();
            }
        },
        validarDatas() {
            const { dataInicio, dataFim, inicioPeriodo, fimPeriodo } = this.form.filters;
    
            const validarIntervalo = (inicio, fim, mensagemInicio, mensagemFim) => {
                if (inicio && fim) {
                    if (new Date(fim) < new Date(inicio)) {
                        this.$notifyWarning(mensagemFim);
                        return false;
                    }
                    if (new Date(inicio) > new Date(fim)) {
                        this.$notifyWarning(mensagemInicio);
                        return false;
                    }
                }
                return true;
            };
            const validoDatas = validarIntervalo(
                dataInicio, 
                dataFim, 
                "A Data Início não pode ser posterior à Data Final", 
                "A Data Final não pode ser anterior à Data Início"
            );
            const validoPeriodos = validarIntervalo(
                inicioPeriodo, 
                fimPeriodo, 
                "O Início do Período não pode ser posterior ao Fim do Período", 
                "O Fim do Período não pode ser anterior ao Início do Período"
            );

            return validoDatas && validoPeriodos;
        },

    
        verificarFiltrosPreenchidos() {
          const { inicioPeriodo, fimPeriodo, situacao, perfil, dataInicio, dataFim } = this.form.filters;
          if (!inicioPeriodo && !fimPeriodo && situacao == null && perfil == null && !dataInicio && !dataFim) {
              this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
              return false;
          }
          
          return true;
        },
    
        async baixarCSVRelatorio() {
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogCSVPeriodoFormacao({ params: this.form.filters });
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeLogDePeríodoFormaçãoCSV`);
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
    
        async baixarRelatorioPdf() {
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogPDFPeriodoFormacao({ params: this.form.filters });
            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeLogDePeríodoFormação.pdf");
            document.body.appendChild(link);
            link.click();
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },

        processarRespostaRelatorio(data) {
            this.form.lists.listRelatorios = data.relatorio.logsPeriodoDeFormacao;
        },

        resetForm() {
          this.form.filters.dataInicio = null;
          this.form.filters.dataFim = null;
          this.form.filters.inicioPeriodo = null;
          this.form.filters.fimPeriodo = null;
    
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicio', null);
            this.$set(this.form.filters, 'dataFim', null);
            this.$set(this.form.filters, 'inicioPeriodo', null);
            this.$set(this.form.filters, 'fimPeriodo', null);
          });
          this.form.filters.perfil = null;
          this.form.filters.situacao = null;

          this.form.lists.listRelatorios = [];
        },
  },
  mounted() {
    this.$buscarPerfis({ params: { situacao: true } }).then(({ data }) => {
      this.form.lists.listPerfis = data.lista;
    });
  }
};
</script>